import { render, staticRenderFns } from "./RemissionModalUpdateProductComponent.vue?vue&type=template&id=77540675"
import script from "./RemissionModalUpdateProductComponent.vue?vue&type=script&lang=js"
export * from "./RemissionModalUpdateProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports